export const GET_TASK_TEMPLATES = 'app/task/GET_TASK_TEMPLATES';
export const POST_TASK_TEMPLATES = 'app/task/POST_TASK_TEMPLATES';

